import Alert from 'utils/Alert/Alert';
import WaitingForPayment from 'components/Checkouts/Checkout/common/WaitingForPayment';
import {PocketTagForm} from './PocketTagForm';
import {STEPS, usePayWithPocket} from './PayWithPocketProvider';
import TransactionStatus from 'components/Checkouts/Checkout/common/TransactionStatus';
import {CLOSE} from 'components/constants';

export const PayWithPocket = () => {
    const {currentState, errorMsg, setErrorMsg, checkoutData} = usePayWithPocket();
    const {timeExpired, timeLeft, sendEvent, frame, reference} = checkoutData;

    const render = () => {
        switch (currentState) {
            case STEPS.POCKET_ID_VERIFICATION:
            default:
                return <PocketTagForm />;

            case STEPS.WAITING_FOR_PAYMENT:
                return <WaitingForPayment timeLeft={timeLeft} />;
        }
    };

    if (timeExpired)
        return (
            <div className="pt-5">
                <TransactionStatus
                    isError
                    title="Transaction has expired"
                    btnName={`${frame ? 'Close' : ''}`}
                    handleClick={() => sendEvent({name: CLOSE, reference})}
                    message={
                        <span>
                            No payment received for this transaction. <br />
                            Contact <b>support@blusalt.net</b> on any issue related to this
                            transaction.
                        </span>
                    }
                />
            </div>
        );

    return (
        <>
            {errorMsg && <Alert {...errorMsg} onClose={() => setErrorMsg()} />}
            {render()}
        </>
    );
};
